import { useSelector } from "react-redux";

// Types
import { AppState } from "../store";
import { Email } from "./types";

export interface EmailsState {
  data: Email[] | null;
  error: string | null;
  loading: boolean;
  hasMore: boolean;
  nextPageCursor: string | null;
  totalCount: number;
}

export const initialState: EmailsState = {
  data: null,
  error: null,
  loading: false,
  hasMore: false,
  nextPageCursor: null,
  totalCount: 0,
};

export interface EmailsHookResult {
  data: Email[] | null;
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  nextPageCursor: string | null;
  totalCount: number;
}

export const useEmails = (): EmailsHookResult => {
  return useSelector<AppState, EmailsHookResult>((state) => ({
    data: state.emails.data,
    loading: state.emails.loading,
    error: state.emails.error,
    hasMore: state.emails.hasMore,
    nextPageCursor: state.emails.nextPageCursor,
    totalCount: state.emails.totalCount,
  }));
};
